export default __webpack_public_path__ + "static/media/Karla-Light.d59df781.ttf";